import { render, staticRenderFns } from "./eventoview.vue?vue&type=template&id=6ecf0237"
import script from "./eventoview.vue?vue&type=script&lang=js"
export * from "./eventoview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports